import React from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import useTranslation from 'next-translate/useTranslation';

export const StoryGameTextPopup = ({
  isLastPopup,
  description,
  onNext,
}: {
  isLastPopup: boolean;
  description: string;
  onNext: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <div css={popupContainer}>
      <div className="bg" />
      <div className="container">
        <div className="text">{description}</div>

        <div className="button-container" onClick={onNext}>
          <div className="button">{t('common_screen_title_confirm')}</div>
        </div>
      </div>
    </div>
  );
};

const popupContainer = css`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #00000040;
    backdrop-filter: blur(8px);
  }

  .container {
    width: 468px;
    background-color: #000000bf;
    padding: 2rem 1.25rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0.625rem;
    border: 1px solid var(--whiteA25, rgba(255, 255, 255, 0.25));

    @media screen and (max-width: ${theme.devices.md}px) {
      width: 100%;
      margin: 1rem;
      padding: 2rem 1rem;
      max-width: 420px;
    }
  }
  .text {
    min-width: 90%;
    text-align: center;
    color: #ffffffe5;
  }

  .button-container {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .button {
    display: flex;
    flex: 1;
    max-width: 50%;
    justify-content: center;
    align-items: center;
    padding: 0.75rem 1rem;

    border-radius: var(--radius-sm, 6px);
    border: 1px solid var(--whiteA25, rgba(255, 255, 255, 0.25));

    cursor: pointer;

    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px; /* 150% */
    background-color: #753bbd;
    color: white;
    border: none;
  }

  @media screen and (max-width: ${theme.devices.mobile}) {
    width: 100%;
  }
`;
